<template>
  <div class="py-2 container-fluid">
    <div
      class="page-header min-height-300 border-radius-xl"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/curved-images/curved14.jpg') + ')',
        backgroundPositionY: '50%',
      }"
    >
      <span class="mask bg-gradient-success opacity-6"></span>
      <div style="display: flex; align-items: center; justify-content: center">
        <div style="position: absolute; left: 50%; transform: translateX(-50%)">
          <img
            :src="logo"
            style="height: 60px; z-index: 999"
            alt="main_logo"
          />
        </div>
      </div>
    </div>
    <div class="mx-4 overflow-hidden card card-body blur shadow-blur mt-n6">
      <div class="row gx-4">
        <div class="col my-auto">
          <!-- <LinesListProLicense v-if="$store.state.flightpath_standard_license"/>
          <LinesListStandardLicense v-if="$store.state.flightpath_pro_license"/> -->

          <LinesListProLicense v-if="$store.state.flightpath_pro_license" />
          <LinesListStandardLicense v-if="$store.state.flightpath_standard_license" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import LinesListProLicense from "./components/LinesListProLicense.vue";
import LinesListStandardLicense from "./components/LinesListStandardLicense.vue";
import logo from "@/assets/img/logo-ct-white.png";

export default {
  name: "FlightPath",
  components: {
    LinesListProLicense,
    LinesListStandardLicense,
  },
  data() {
    return {
      logo,
    };
  },
  computed: {},
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {},
};
</script>
